import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../_ui/Modal/Modal';
import { ServiceRequestApi } from '../ServiceRequestApi';
import { changeFormValue } from '../../../passport/Passport';
import { handleError } from '../../../modules/utils/handleError';
import DialogContent from '@material-ui/core/DialogContent';
import { Table } from '../ServiceProvidersModal/ServiceProvidersModalStyles';

function ListChildrenModalForServices({ close, isOpen, data }) {
  const metadataKey = data.code.split('.')[0];
  const { t } = useTranslation();
  const [listChildren, setListChildren] = useState([]);
  const [loading, setLoading] = useState(false);
  const requestForChildren = async () => {
    try {
      setLoading(true);
      const { data } = await ServiceRequestApi.getChildrenFromIntegration();
      if (data.status === 'SUCCESS') {
        setListChildren(data.result);
      }
    } catch (error) {
      handleError(error, t('serviceProviders_exitedErrorListChildren'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    requestForChildren();
  }, []);
  const selectChildren = children => {
    changeFormValue(`${metadataKey}.child_iin`, children['iin']);

    changeFormValue(`${metadataKey}.child_surname`, children['lastname']);
    changeFormValue(`${metadataKey}.child_name`, children['firstname']);
    changeFormValue(`${metadataKey}.child_middlename`, children['middlename']);
    changeFormValue(`${metadataKey}.child_birthday`, children['birthday']);
    close();
  };
  return (
    <Modal open={isOpen} onClose={close} title={t('serviceRequest_listChildren')}>
      <DialogContent dividers>
        <Table
          loading={loading}
          columns={[
            {
              Header: t('serviceProviders_fioChild'),
              filterable: false,
              Cell: ({ original }) => {
                const { lastname, firstname, middlename } = original;
                return [lastname, firstname, middlename].filter(Boolean).join(' ');
              }
            },
            {
              Header: t('serviceProviders_columnIin'),
              filterable: false,
              width: 150,
              Cell: ({ original }) => original.iin
            }
          ]}
          onClickRow={({ original }) => selectChildren(original)}
          data={listChildren}
        />
      </DialogContent>
    </Modal>
  );
}

export default ListChildrenModalForServices;
